var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdv1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 60,
    viewBox: "0 0 97 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_100790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.100586 28.1669C0.100586 26.7112 1.06708 25.2554 3.00008 24.1447L41.5001 2.02223C45.366 -0.199162 51.6341 -0.199202 55.5001 2.02223L94 24.1447C95.933 25.2554 96.899 26.7111 96.899 28.1669V32.1892C96.899 30.7334 95.933 29.2776 94 28.1669L55.5001 6.04449C51.6341 3.82306 45.366 3.8231 41.5001 6.04449L3.00008 28.1669C1.06708 29.2776 0.100586 30.7334 0.100586 32.1892V28.1669Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_696_100790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.899 28.1671C96.899 29.6229 95.933 31.0787 94 32.1894L55.5001 54.3118C51.6341 56.5333 45.366 56.5332 41.5001 54.3118L3.00008 32.1894C1.06708 31.0787 0.100586 29.6229 0.100586 28.1671V32.1894C0.100586 33.6451 1.06708 35.1009 3.00008 36.2116L41.5001 58.3341C45.366 60.5555 51.6341 60.5555 55.5001 58.3341L94 36.2116C95.933 35.1009 96.899 33.6452 96.899 32.1894V28.1671Z",
    fill: "url(#paint0_linear_696_100790)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6671 2.12778L3.18368 24.2407C-0.590133 26.4091 -0.590133 29.9249 3.18368 32.0934L41.6671 54.2063C45.4409 56.3747 51.5595 56.3747 55.3333 54.2063L93.8167 32.0934C97.5905 29.9249 97.5905 26.4091 93.8167 24.2407L55.3333 2.12778C51.5595 -0.040689 45.4409 -0.0406878 41.6671 2.12778Z",
    fill: "white",
    stroke: "#EBF4FF",
    strokeWidth: 0.404145
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0684 34.5769L30.2709 31.4985C28.9568 30.4333 29.0305 29.0067 30.4509 28.015L34.9335 24.8853C35.8737 24.2289 37.282 23.853 38.774 23.8604L58.7709 23.959C61.5329 23.9726 63.791 25.2702 63.8147 26.8572L63.9075 33.0691C63.9312 34.6561 61.7114 35.9316 58.9495 35.918L38.1747 35.8156C36.5482 35.8076 35.0166 35.3456 34.0684 34.5769ZM33.0398 29.2474C32.5664 29.578 32.5418 30.0535 32.9798 30.4086L36.7773 33.487C37.0934 33.7432 37.6039 33.8972 38.1461 33.8999L58.9209 34.0023C59.8415 34.0068 60.5814 33.5817 60.5735 33.0527L60.4808 26.8407C60.4729 26.3117 59.7202 25.8792 58.7996 25.8747L38.8026 25.7761C38.3053 25.7737 37.8358 25.8989 37.5225 26.1177L33.0398 29.2474ZM39.2951 28.8262C40.2716 28.831 41.07 29.2897 41.0783 29.8508C41.0867 30.4119 40.3019 30.8629 39.3254 30.8581C38.349 30.8533 37.5506 30.3945 37.5422 29.8334C37.5338 29.2723 38.3186 28.8213 39.2951 28.8262Z",
    fill: "#3399CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_696_100790",
    x: 0.100586,
    y: 28.1671,
    width: 96.7983,
    height: 34.2579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_696_100790"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42487
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_696_100790",
    result: "effect2_innerShadow_696_100790"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.04145
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_696_100790",
    result: "effect3_innerShadow_696_100790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_100790",
    x1: 0.100586,
    y1: 28.1671,
    x2: 24.9289,
    y2: 88.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AED6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3399CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_100790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv1);
export default __webpack_public_path__ + "static/media/adv-1.29db04a4b31beda6a7a14f1860aae671.svg";
export { ForwardRef as ReactComponent };